var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "manual" }, [
    _vm._m(0),
    _c("h3", { staticClass: "title-know" }, [
      _vm._v("以下是使用须知，请仔细阅读！")
    ]),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
    _vm._m(4),
    _c("div", { staticClass: "manual-btn" }, [
      _c("p", [_vm._v("上述操作都完成后，就可以开始接单啦！")]),
      _vm.showIKnow
        ? _c(
            "div",
            { staticClass: "btn-bottom" },
            [
              _c("customBtn", {
                attrs: {
                  "custom-style": { width: "200px", height: "40px" },
                  text: "我知道了"
                },
                on: { handleClick: _vm.handleClose }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-in" }, [
      _c("p", { staticClass: "title" }, [_vm._v("欢迎入驻好身体药店端")]),
      _c("div", { staticClass: "text" }),
      _c("div", { staticClass: "steps" }, [
        _c("div", { staticClass: "steps-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/login/icon_stores.png"), alt: "" }
          }),
          _c("p", [_vm._v("维护门店信息")])
        ]),
        _c("div", { staticClass: "steps-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/login/icon_goods.png"), alt: "" }
          }),
          _c("p", [_vm._v("维护商品信息")])
        ]),
        _c("div", { staticClass: "steps-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/login/icon_config.png"), alt: "" }
          }),
          _c("p", [_vm._v("经营配置")])
        ]),
        _c("div", { staticClass: "steps-item" }, [
          _c("img", {
            attrs: { src: require("@/assets/login/icon_in.png"), alt: "" }
          }),
          _c("p", [_vm._v("运费模板")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "basic-info" }, [
      _c("div", { staticClass: "title-box" }, [
        _c("h3", [
          _c("i", { staticClass: "store" }),
          _vm._v(" 维护门店基本信息")
        ]),
        _c("div", { staticClass: "line" })
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(" 1.【基础信息】-【门店信息】：选择未完善模块进行编辑。 ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "basic-info" }, [
      _c("div", { staticClass: "title-box" }, [
        _c("h3", [_c("i", { staticClass: "goods" }), _vm._v(" 维护商品信息")]),
        _c("div", { staticClass: "line" })
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(
          " 1.【基础信息】-【商品库】：上传您的商品资料并选择线上售卖的商品； "
        )
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(" 2.【店铺运营】-【商品铺货】：配置商品销售信息并上架。 ")
      ]),
      _c("div", { staticClass: "icon-arrow" }, [_c("i")]),
      _c("div", { staticClass: "icon-arrow" }, [_c("i")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "basic-info" }, [
      _c("div", { staticClass: "title-box" }, [
        _c("h3", [_c("i", { staticClass: "config" }), _vm._v(" 经营配置")]),
        _c("div", { staticClass: "line" })
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(" 【店铺运营】-【经营配置】：完成经营状态和接单配置。 ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "basic-info" }, [
      _c("div", { staticClass: "title-box" }, [
        _c("h3", [_c("i", { staticClass: "freight" }), _vm._v(" 运费模板")]),
        _c("div", { staticClass: "line" })
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(
          " 【店铺运营】-【运费模板】：完成已开通的接单渠道下普通快递、加急快递、骑手配送的运费模板。 "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }